import SectionHeader from "../components/common/SectionHeader";
import { useIntegrations } from "../hooks/data";
import { app } from "../application";
import { VERTICALS, DEFAULT_VERTICAL_ID } from "../config/vertical";
import { DEFAULT_ORGANIZATION_NAME } from "../config/vertical";
import { isCommercialContext } from "../config/environment";
import { Link } from "react-router-dom";
import { Plug, Cpu, MessageSquare, BookOpen, Zap, ClipboardCheck } from "lucide-react";

const CATEGORY_ICON = {
  crm: Plug,
  channel: MessageSquare,
  intelligence: Cpu,
  knowledge: BookOpen,
  protocol: Zap,
};

const CATEGORY_LABEL = {
  crm: "Origen de datos",
  channel: "Canal",
  intelligence: "Inteligencia",
  knowledge: "Conocimiento",
  protocol: "Protocolo",
};

export default function Settings() {
  const { data: integrations } = useIntegrations();
  const bindings = app.config.portBindings();
  const commercial = isCommercialContext();

  return (
    <div className="ambient-bg min-h-full">
      <div className="px-8 pt-8 pb-6 border-b border-[#17223a]">
        <SectionHeader
          overline="Ajustes"
          title="Configuración de la plataforma"
          subtitle="Vertical activo y organización."
        />
      </div>

      <div className="p-8 grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-6xl">
        {/* Organización */}
        <div className="border border-[#17223a] bg-[#0d1321] p-6">
          <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500 mb-3">
            Organización
          </div>
          <div className="font-display font-bold text-lg text-zinc-100 mb-4">
            {DEFAULT_ORGANIZATION_NAME}
          </div>
        </div>

        {/* Vertical */}
        <div className="border border-[#17223a] bg-[#0d1321] p-6">
          <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500 mb-3">
            Vertical activo
          </div>
          <div className="font-display font-bold text-lg text-zinc-100 mb-4">
            {VERTICALS.find((v) => v.id === DEFAULT_VERTICAL_ID)?.label}
          </div>
          <div className="text-xs text-zinc-500 leading-relaxed">
            El vertical define qué señales importan, qué canales están disponibles y
            cómo se estima el valor comercial para tu tipo de negocio.
          </div>
        </div>

        {/* Detalle técnico — solo visible fuera de un contexto comercial
            (beta_founder/production). Abel/Guillermo nunca ven esto. */}
        {!commercial && (
          <>
            <Link
              to="/entrega"
              className="border border-amber-500/30 bg-amber-500/5 p-6 hover:border-amber-500/60 transition-colors flex items-center gap-3 lg:col-span-2"
            >
              <ClipboardCheck size={20} className="text-amber-400 shrink-0" />
              <div>
                <div className="text-sm font-medium text-zinc-100">Checklist de entrega</div>
                <div className="text-xs text-zinc-500">Verificación previa a invitar a un Socio Fundador</div>
              </div>
            </Link>

            <div className="border border-[#17223a] bg-[#0d1321] p-6">
              <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500 mb-3">
                Bindings de puertos → adaptadores (solo desarrollo)
              </div>
              <div className="space-y-2 text-xs font-mono">
                {Object.entries(bindings).map(([port, adapter]) => (
                  <div key={port} className="flex items-center justify-between border-b border-[#101728] pb-1.5 last:border-0">
                    <span className="text-zinc-400 uppercase tracking-[0.15em]">{port}</span>
                    <span className="text-amber-400 tabular-nums">{adapter}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="border border-[#17223a] bg-[#0d1321] p-6 lg:col-span-2">
              <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500 mb-4">
                Integraciones (solo desarrollo)
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                {(integrations || []).map((i) => {
                  const Icon = CATEGORY_ICON[i.category] || Plug;
                  return (
                    <div key={i.id} className="border border-[#17223a] p-4 flex items-center gap-3">
                      <Icon size={18} className="text-zinc-500" />
                      <div className="flex-1 min-w-0">
                        <div className="text-sm text-zinc-100">{i.label}</div>
                        <div className="text-[10px] font-mono uppercase tracking-[0.15em] text-zinc-500">
                          {CATEGORY_LABEL[i.category]} · {i.status === "connected" ? "conectado" : "sin conectar"}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
